import gql from "graphql-tag";

export default {
  get: gql`
    query SendEmailCell($id: ID!) {
      sendEmailCell(id: $id) {
        id
        cell_type
        placeholder
      }
    }
  `,
  update: gql`
    mutation UpdateSendEmailCell($input: UpdateSendEmailCellInput!) {
      updateSendEmailCell(input: $input) {
        id
        placeholder
      }
    }
  `,
};
